import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Navigate } from "react-router";

//TODO refactor to FC
/**Helper class to switch between different logins.*/
class Start extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirectTo: null,
    };
  }

  componentDidMount() {
    document.title = this.props.title;
  }

  /**Open patient login page. */
  handlePatient = (event) => {
    event.preventDefault();
    this.setState({ redirectTo: "/loginpatient" });
  };

  /**Open clinician login page. */
  handleClinician = (event) => {
    event.preventDefault();
    this.setState({ redirectTo: "/loginclinician" });
  };

  /**Open admin login page. */
  handleAdmin = (event) => {
    event.preventDefault();
    this.setState({ redirectTo: "/loginadmin" });
  };

  /**Open admin registration page. */
  handleRegist = (event) => {
    event.preventDefault();
    this.setState({ redirectTo: "/regist" });
  };

  /**React render method. */
  render() {
    // Handle navigation using Navigate component
    if (this.state.redirectTo) {
      return <Navigate to={this.state.redirectTo} replace />;
    }

    return (
      <Form>
        <Form.Group>
          <Button variant="primary" type="button" onClick={this.handlePatient}>
            Patient
          </Button>
          <Button
            variant="primary"
            type="button"
            onClick={this.handleClinician}
          >
            Clinician
          </Button>
          <Button variant="primary" type="button" onClick={this.handleAdmin}>
            Clinic-Admin
          </Button>
          <Button variant="primary" type="button" onClick={this.handleRegist}>
            Admin registrieren
          </Button>
        </Form.Group>
      </Form>
    );
  }
}

export default Start;
